import { required, ColorOptions } from '@jfs/ui-new'
import { Dropdown } from '../../components/Dropdown'
import { MidVerify } from './MidVerify'

const textinputStyle = {
  type: 'body14',
  borderColor: '#d1d3e2' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: '#6e707e' as ColorOptions,
  labelFontSize: 12,
  fontSize: 14,
  selectionColor: 'BLUE',
  paddingHorizontal: 8,
  color: '#6e707e' as ColorOptions,
  paddingVertical: 8,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  borderWidth: 2,
  onFocusBorderWidth: 2,
}

const formData: any = (packageNames: any, onVerifyMid: any, onSubmit: (values: any) => void, onMidChange: any) => [
  {
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'mid',
            ComponentName: MidVerify,
            placeholder: 'Merchant Id',
            onChangeText: onMidChange,
            validationSchema: required,
            ...textinputStyle,
            verifyMid: (mid: any) => onVerifyMid(mid),
          },
          {
            fieldName: 'packageName',
            ComponentName: Dropdown,
            title: 'Package Name',
            validationSchema: required,
            data: packageNames,
          },
        ],
      },
    ],
    horizontalFlex: 1,
    onSubmit: async (values: any) => {
      onSubmit(values)
      return 'end'
    },
    actionTitle: 'Submit',
  },
]

export { formData }
